export default {"src":"/_next/static/media/icon-usa-made.bb143950.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};